
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live",
      function () {
        return require("private-next-pages/live/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live"])
      });
    }
  